import React, { PureComponent } from 'react';
import { bool } from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../constants/colors';
import { fontFamily } from '../../constants/text';

const Badge = styled.div.withConfig({ componentId: 'sc-l7mrbd-0' })`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isInNetwork' does not exist on type 'The... Remove this comment to see the full error message
    props.isInNetwork ? colors.purpSizzurp : colors.lightText};
  font-family: ${fontFamily.bold};
  background-color: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isInNetwork' does not exist on type 'The... Remove this comment to see the full error message
    props.isInNetwork ? colors.pinkish : colors.greyHairs};
  font-size: 9px;
  border-radius: 10px;
  width: fit-content;
  height: 18px;
  padding: 0 8px;
  letter-spacing: 0.16px;
`;

type Props = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'bool' refers to a value, but is being used as a t... Remove this comment to see the full error message
  isInNetwork: bool;
};

export default class NetworkStatusBadge extends PureComponent<Props> {
  render = () => {
    const { isInNetwork } = this.props;

    // @ts-expect-error ts-migrate(2769) FIXME: Property 'isInNetwork' does not exist on type 'Int... Remove this comment to see the full error message
    return <Badge isInNetwork={isInNetwork}>{isInNetwork ? 'IN-NETWORK' : 'OUT-OF-NETWORK'}</Badge>;
  };
}
